export const PHOTO_SELECTION_CONTROL_FACES_OPTIONS = {
  ALL: 'ALL',
  INDIVIDUAL: 'INDIVIDUAL',
  MULTIPLE: 'MULTIPLE',
};
